import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  DestinationCountryState,
  DESTINATION_COUNTRY_STATE,
} from './destination-country.state';

export const selectDestinationCountryState =
  createFeatureSelector<DestinationCountryState>(DESTINATION_COUNTRY_STATE);

export const selectDestinationCountry = createSelector(
  selectDestinationCountryState,
  (state: DestinationCountryState) => {
    return state.data;
  }
);

export const selectDestSourceCurrency = createSelector(
  selectDestinationCountryState,
  (state: DestinationCountryState) => {
    return state.sourceCurrency;
  }
);
